import styled from "styled-components";

export const AboutMeSection = styled.section`
  width: 90vw;
  padding-top: 20px;

  h2 {
    height: 80px;
    margin-left: 10%;
  }

  .main {
    display: flex;
    margin-left: 10%;
    gap: 10%;
    .left {
      img {
        max-height: 50vh;
      }
    }


  }
`;
